import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { useCallback, useRef, useState } from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Icon from "@/components/icon/Icon";
import { Close, Search, Sizes } from "@/components/icon/IconList";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Portal } from "@mui/material";
import useSnackbar, { defaultSnackbarProps, IconWithSnackbarMessage, Snackbar } from "../Snackbar";
export const SearchTextField = (param)=>{
    let { onClickForm , onSubmit , placeholder , onBlur , onClear , value , onChange , onSearchClick , autoFocus , ...props } = param;
    const { isMobile  } = useWindowDimensions();
    const { isShowSnackbar , hideSnackbar , showSnackbar  } = useSnackbar();
    const [focused, setFocused] = useState(false);
    const inputRef = useRef({
        element: null,
        focusTimeout: null
    });
    const handleFocus = useCallback(()=>{
        clearTimeout(inputRef.current.focusTimeout);
        setFocused(true);
    }, []);
    const handleBlur = useCallback(()=>{
        inputRef.current.focusTimeout = setTimeout(()=>{
            setFocused(false);
        }, 100);
        if (onBlur) {
            onBlur();
        }
    }, [
        onBlur
    ]);
    const handleClear = useCallback(()=>{
        if (onClear) {
            onClear();
        }
        if (inputRef.current.element) {
            inputRef.current.element.focus();
        }
    }, [
        onClear
    ]);
    const handleOnChange = useCallback((e)=>{
        if (onChange) {
            if (e.target.value.trim().length === 0) {
                showSnackbar();
                return;
            }
            onChange(e);
        }
    }, [
        onChange
    ]);
    const handleOnSubmit = useCallback((e)=>{
        e.preventDefault();
        if (onSubmit) {
            if (value.trim().length === 0) {
                showSnackbar();
                return;
            }
            onSubmit(e);
        }
    }, [
        onSubmit,
        value
    ]);
    const handleOnSearchClick = useCallback((e)=>{
        e.preventDefault();
        if (onSearchClick) {
            if (value.trim().length === 0) {
                showSnackbar();
                return;
            }
            onSearchClick(e);
        }
    }, [
        onSearchClick,
        value
    ]);
    return /*#__PURE__*/ _jsxs(Paper, {
        onClick: onClickForm,
        onSubmit: handleOnSubmit,
        onFocus: handleFocus,
        onBlur: handleBlur,
        component: "form",
        className: "search-request-form ".concat(focused || (value === null || value === void 0 ? void 0 : value.length) ? "active" : ""),
        sx: (theme)=>{
            return {
                p: "12px 12px 12px 20px ",
                display: "flex",
                alignItems: "center",
                borderRadius: "24px",
                height: "48px",
                width: "400px",
                backgroundColor: "rgba(169, 175, 199, 0.2)",
                "&.active": {
                    backgroundColor: "#fff",
                    border: "1px solid ".concat(theme.palette.grey[700]),
                    transition: "all 0.2s"
                },
                input: {
                    p: 0,
                    ...theme.typography.body1
                },
                [theme.breakpoints.down("sm")]: {
                    width: "100%",
                    marginRight: "8px"
                }
            };
        },
        children: [
            /*#__PURE__*/ _jsx(InputBase, {
                ...props,
                onChange: onChange,
                autoFocus: autoFocus,
                ref: inputRef,
                value: value,
                autoComplete: "off",
                sx: {
                    flexGrow: 1
                },
                placeholder: placeholder
            }),
            (value === null || value === void 0 ? void 0 : value.length) > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(IconButton, {
                        type: "button",
                        onClick: handleClear,
                        color: "primary",
                        sx: (theme)=>{
                            return {
                                p: "8px",
                                i: {
                                    backgroundColor: theme.palette.grey[800],
                                    borderRadius: "50%",
                                    padding: "2px"
                                }
                            };
                        },
                        children: /*#__PURE__*/ _jsx(Icon, {
                            icon: Close,
                            size: isMobile ? Sizes.xxsmall : Sizes.xsmall,
                            color: "#fff"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Divider, {
                        sx: {
                            height: 12,
                            m: 1
                        },
                        orientation: "vertical"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                onClick: handleOnSearchClick,
                sx: {
                    p: "8px"
                },
                type: "submit",
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: Search,
                    size: isMobile ? Sizes.small : Sizes.xmedium
                })
            }),
            /*#__PURE__*/ _jsx(Portal, {
                children: /*#__PURE__*/ _jsx(Snackbar, {
                    ...defaultSnackbarProps,
                    open: isShowSnackbar,
                    onClose: hideSnackbar,
                    autoHideDuration: 2000,
                    message: /*#__PURE__*/ _jsx(IconWithSnackbarMessage, {
                        text: "검색어를 1글자 이상 입력해주세요."
                    })
                })
            })
        ]
    });
};
